import { Home, BookOpen, User } from "lucide-react";
import { NavLink } from "./NavLink";

const MobileBottomNav = () => {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around py-2 px-4">
        <NavLink
          to="/home"
          className="flex flex-col items-center gap-1 px-4 py-2 rounded-lg text-muted-foreground transition-colors min-w-[64px]"
          activeClassName="text-primary font-medium"
        >
          <Home className="w-5 h-5" />
          <span className="text-xs">Home</span>
        </NavLink>
        <NavLink
          to="/library"
          className="flex flex-col items-center gap-1 px-4 py-2 rounded-lg text-muted-foreground transition-colors min-w-[64px]"
          activeClassName="text-primary font-medium"
        >
          <BookOpen className="w-5 h-5" />
          <span className="text-xs">Library</span>
        </NavLink>
        <NavLink
          to="/account"
          className="flex flex-col items-center gap-1 px-4 py-2 rounded-lg text-muted-foreground transition-colors min-w-[64px]"
          activeClassName="text-primary font-medium"
        >
          <User className="w-5 h-5" />
          <span className="text-xs">Account</span>
        </NavLink>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
